import React from "react";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// library used for cool animations
// import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";

import contentStyle from "assets/jss/material-kit-pro-react/views/contentStyle.js";
// images

import GST_CERTIFICATE_INSHA_BANGALES_PVT_LTD from "assets/img/GST-CERTIFICATE-INSHA-BANGALES-PVT-LTD.jpg";
import GST_CERTIFICATE_INSHA_BANGALES_PVT_LTD_2 from "assets/img/GST-CERTIFICATE-INSHA-BANGALES-PVT-LTD-2.jpg";
import GST_CERTIFICATE_INSHA_BANGALES_PVT_LTD_3 from "assets/img/GST-CERTIFICATE-INSHA-BANGALES -PVT-LTD.jpg";
import Incorporation_of_Certificate_INSHA_BANGALES_PVT_LTD from "assets/img/Incorporation-of-Certificate-INSHA-BANGALES -PVT-LTD.jpg";
import UDYAM_AADHAR_INSHA_BANGALES_PVT_LTD from "assets/img/UDYAM AADHAR INSHA BANGALES PVT LTD_page-0001.jpg";
import UDYAM_AADHAR_INSHA_BANGALES_PVT_LTD_page_0002 from "assets/img/UDYAM AADHAR INSHA BANGALES PVT LTD_page-0002.jpg";
import UDYAM_AADHAR_INSHA_BANGALES_PVT_LTD_page_0003 from "assets/img/UDYAM AADHAR INSHA BANGALES PVT LTD_page-0003.jpg";
import UDYAM_AADHAR_INSHA_BANGALES_PVT_LTD_page_0004 from "assets/img/UDYAM AADHAR INSHA BANGALES PVT LTD_page-0004.jpg";
import UDYAM_AADHAR_INSHA_BANGALES_PVT_LTD_page_0005 from "assets/img/UDYAM AADHAR INSHA BANGALES PVT LTD_page-0005.jpg";
import INSHA_BANGLES_PRIVATE_LIMITED_page_0001 from "assets/img/INSHA BANGLES PRIVATE LIMITED_page-0001.jpg"

const useStyles = makeStyles(contentStyle);

export default function LicencesDescription() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <br />
        <br />
        <GridContainer justify="center">
          <GridItem md={8} className={classes.mlAuto}>
            <div className={classes.imageContainer}>
              <img
                className={classes.ipadImg}
                src={Incorporation_of_Certificate_INSHA_BANGALES_PVT_LTD}
                alt="Incorporation_of_Certificate_INSHA_BANGALES_PVT_LTD"
              />
            </div>
          </GridItem>
          <GridItem md={4}>
            <div className={classes.sectionDescription}>
              <h3 className={classes.title}>Government of India</h3>
              <h6 className={classes.description}>
                CERTIFICATE of Importer-Exporter Code (IEC)
              </h6>
              <h5 className={classes.description}>
                {/* Acquired the Importer & Exporter Certificate from Government of
                India */}
                I have obtained the Importer & Exporter Certificate from the
                Government of India, dated 27/03/2026.
              </h5>
            </div>
          </GridItem>
        </GridContainer>
        <br />
        <br />
        <GridContainer justify="center">
          <GridItem md={4}>
            <div className={classes.sectionDescription}>
              <h3 className={classes.title}>Government of india</h3>
              <h6 className={classes.description}>
                Udyog Aadhaar Registration Certificate
              </h6>
              <h5 className={classes.description}>
                {/* Acquired the Udyog Aadhaar Certificate from Government of India */}
                I have obtained the Udyog Aadhaar Certificate from the
                Government of India, with the date of Udyam registration being
                15/04/2026.
              </h5>
            </div>
          </GridItem>
          <GridItem md={8} className={classes.mlAuto}>
            <div className={classes.imageContainer}>
              <img
                className={classes.ipadImg}
                src={UDYAM_AADHAR_INSHA_BANGALES_PVT_LTD}
                alt="UDYAM_AADHAR_INSHA_BANGALES_PVT_LTD"
              />
            </div>
            <div className={classes.imageContainer}>
              <img
                className={classes.ipadImg}
                src={UDYAM_AADHAR_INSHA_BANGALES_PVT_LTD_page_0002}
                alt="UDYAM_AADHAR_INSHA_BANGALES_PVT_LTD_page_0002"
              />
            </div>
            <div className={classes.imageContainer}>
              <img
                className={classes.ipadImg}
                src={UDYAM_AADHAR_INSHA_BANGALES_PVT_LTD_page_0003}
                alt="UDYAM_AADHAR_INSHA_BANGALES_PVT_LTD_page_0003"
              />
            </div>
            <div className={classes.imageContainer}>
              <img
                className={classes.ipadImg}
                src={UDYAM_AADHAR_INSHA_BANGALES_PVT_LTD_page_0004}
                alt="UDYAM_AADHAR_INSHA_BANGALES_PVT_LTD_page_0004"
              />
            </div>
            <div className={classes.imageContainer}>
              <img
                className={classes.ipadImg}
                src={UDYAM_AADHAR_INSHA_BANGALES_PVT_LTD_page_0005}
                alt="UDYAM_AADHAR_INSHA_BANGALES_PVT_LTD_page_0005"
              />
            </div>
          </GridItem>
        </GridContainer>
        <br />
        <br />
        <GridContainer justify="center">
          <GridItem md={8} className={classes.mlAuto}>
            <div className={classes.imageContainer}>
              <img
                className={classes.ipadImg}
                src={GST_CERTIFICATE_INSHA_BANGALES_PVT_LTD}
                alt="GST_CERTIFICATE_INSHA_BANGALES_PVT_LTD"
              />
            </div>
            <div className={classes.imageContainer}>
              <img
                className={classes.ipadImg}
                src={GST_CERTIFICATE_INSHA_BANGALES_PVT_LTD_2}
                alt="GST_CERTIFICATE_INSHA_BANGALES_PVT_LTD_2"
              />
            </div>
            <div className={classes.imageContainer}>
              <img
                className={classes.ipadImg}
                src={GST_CERTIFICATE_INSHA_BANGALES_PVT_LTD_3}
                alt="GST_CERTIFICATE_INSHA_BANGALES_PVT_LTD_3"
              />
            </div>
          </GridItem>
          <GridItem md={4}>
            <div className={classes.sectionDescription}>
              <h3 className={classes.title}>Government of India</h3>
              <h6 className={classes.description}>
                GST Registration Certificate
              </h6>
              <h5 className={classes.description}>
                {/* Acquired the GST Certificate from Government of India */}I
                have obtained the GST Certificate from the Government of India,
                with validity effective from 13/04/2026.
              </h5>
            </div>
          </GridItem>
        </GridContainer>
        <br />
        <br />
        <GridContainer justify="center">
          <GridItem md={4}>
            <div className={classes.sectionDescription}>
              <h3 className={classes.title}>Government of india</h3>
              <h6 className={classes.description}>
                Certificate of Recognition
              </h6>
              <h5 className={classes.description}>
                {/* Acquired the Udyog Aadhaar Certificate from Government of India */}
                I have obtained the Certificate of Recognition from the
                Government of India, with the date of Recognition registration being
                30/04/2026.
              </h5>
            </div>
          </GridItem>
          <GridItem md={8} className={classes.mlAuto}>
            <div className={classes.imageContainer}>
              <img
                className={classes.ipadImg}
                src={INSHA_BANGLES_PRIVATE_LIMITED_page_0001}
                alt="INSHA_BANGLES_PRIVATE_LIMITED_page_0001"
              />
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
